import { render, staticRenderFns } from "./GraphHeader.vue?vue&type=template&id=f20a5984&"
import script from "./GraphHeader.vue?vue&type=script&lang=ts&"
export * from "./GraphHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports